import { FilterDescriptor } from '@progress/kendo-data-query'
import { useAppSelector } from 'store'

import { SelectFilter } from '../SelectFilter'

export const ClientTypeFilter = ({
  filter,
  onFilterChange,
}: {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}): JSX.Element => {
  const types = useAppSelector((state) => state.clients.types)

  const data = types.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return (
    <SelectFilter
      placeholder='Client Type'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
    />
  )
}
